import ApiService from '@/services/core/api.service'

const ScheduleVehiclesService = {
  async get (query) {
    return ApiService.get(`logistics-officer/schedule/vehicles?${query}`)
  },

  async histories (query) {
    return ApiService.get(`logistics-officer/reports/schedule/vehicle-histories?${query}`)
  },

  async exports (query) {
    return ApiService.get(`logistics-officer/export/schedule/vehicle-histories?${query}`)
  },

  async post (payload) {
    return ApiService.post('logistics-officer/schedule/vehicles', payload)
  },

  async put (payload) {
    return ApiService.put(`logistics-officer/schedule/vehicles/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`logistics-officer/schedule/vehicles/${payload.id}`)
  }
}

export default ScheduleVehiclesService
